import React, { Component } from 'react';
import TournamentItem from "./TournamentItem";
import FormGroup from "react-bootstrap/FormGroup";
import moment from "moment";
import { FiAnchor, FiLock, FiSearch } from 'react-icons/fi';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "react-bootstrap/Button";
import TournamentStep1 from "./TournamentStep1";
import TournamentStep2 from "./TournamentStep2";
import noImage from "../../assets/img/no-img2.png";
import { API_BASE_URL } from "../../constatns";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {isMobile} from 'react-device-detect';
import { Trans } from "react-i18next";
import ReactGA from "react-ga";

class TournamentPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isList: true,
			message: "",
			activeStep: 0,
			isOpenActive: false,
			isRegisterActive: false,
			isClosedActive: false,
			isPublicActive: false,
			isPrivateActive: false,
			isConditionalActive: false,
		};

		this.createTournament = this.createTournament.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.setActiveStep = this.setActiveStep.bind(this);
		this.sendFishData = this.sendFishData.bind(this);
		this.searchList = this.searchList.bind(this);
	}

	componentDidMount() {

		fetch(API_BASE_URL+'/common/fish?lang=kr', {
			method: 'GET',
		}).then(res => res.text())
		.then(body => {
			let result = JSON.parse(body);
			this.setState({fish: result});
		});

		this.getList();
	}

	searchList(st, e) {
		e.preventDefault();

		if(st === 'search') {
			const word = document.getElementById('searchKeyword').value;
			this.getList(null, word);
		} else {

			if(st === 'open') {
				this.setState({isOpenActive : !this.state.isOpenActive});
			}
			if(st === 'closed') {
				this.setState({isClosedActive : !this.state.isClosedActive});
			}
			if(st === 'register') {
				this.setState({isRegisterActive : !this.state.isRegisterActive});
			}
			if(st === 'public') {
				this.setState({isPublicActive : !this.state.isPublicActive});
			}
			if(st === 'private') {
				this.setState({isPrivateActive : !this.state.isPrivateActive});
			}
			if(st === 'conditional') {
				this.setState({isConditionalActive : !this.state.isConditionalActive});
			}

			setTimeout(()=> {
				this.getList(st);
			}, 100);

		}
	}

	getList(_status, _keyword) {
		let status = '', keyword = '', _public_ = '';
		let arrStatus = new Array(), arrPublic = new Array();
		if(this.state.isOpenActive) arrStatus.push('open');
		if(this.state.isRegisterActive) arrStatus.push('register');
		if(this.state.isClosedActive) arrStatus.push('closed');

		if(this.state.isPublicActive) arrPublic.push('public');
		if(this.state.isPrivateActive) arrPublic.push('private');
		if(this.state.isConditionalActive) arrPublic.push('conditional');

		if(arrStatus.length > 0) {
			status = '&status=' + arrStatus.join();
		}
		if(arrPublic.length > 0) {
			_public_ = '&public=' + arrPublic.join();
		}

		if(_keyword) keyword = '&keyword='+_keyword;
		fetch(`${API_BASE_URL}/tournament/list?limit=30${status}${_public_}${keyword}`, {
			method: 'GET',
		}).then(res => res.text())
			.then(body => {
				let result = JSON.parse(body);
				console.log(result);
				if(!result.datas) return;
				const items = result.datas.map((item, index) => {

					const startDT = moment(new Date(1 * (item.tournament_period.start))).format('L');
					const endDT = moment(new Date(1 * (item.tournament_period.end))).format('L');

					const memCnt = (item.participants) ? (item.participants.length) : 0;
					let fish = "";
					if (item.fish) {
						if (item.fish.length === 0) {
							fish = "any";
						} else {
							for (let i = 0; i < item.fish.length; i++) {
								fish += item.fish[i].name;
								if (i !== item.fish.length - 1) fish += ", ";
							}
						}
					} else {
						fish = "any";
					}
					let tools = "";
					if (item.measure_tools) {
						for (let i = 0; i < item.measure_tools.length; i++) {
							tools += item.measure_tools[i].name;
							if (i !== item.measure_tools.length - 1) tools += ", ";
						}
					}

					return (
						<div className="col-md-6 col-lg-6 col-xl-4 post-list" key={index}>
							<div className="card custom-card pd-0">
								<TournamentItem
									key={item.id}
									id={item.id}
									imgUrl={item.img ? item.img : noImage}
									title={item.title}
									owner={item.owner[0].username}
									date={startDT + ' ~ ' + endDT}
									tn_type={tools}
									tn_fish={fish}
									tn_members={memCnt}
									tn_desc={item.desc}
									tn_public_type={item.public_type.name}
									owner_img={item.owner[0].image_url}
									status={item.status.name}
									register_status={item.register_status.name}
									catchCount={item.catchCount}
								/>
							</div>
						</div>
					);
				});

				this.setState({items: items});

			});
	}

	createTournament(e) {
		e.preventDefault();
		this.setState({isList: !this.state.isList});
	}

	setActiveStep(idx) {
		this.setState({activeStep: idx});
	}

	handleSubmit(e) {
		e.preventDefault();
		// this.setState({message: 'Sending...'}, this.sendFormData);
	}

	sendFishData(fish) {
		this.setState({selectedFish: fish});
	}

	getSteps() {
		return ['Information', 'Fish Species', 'Select Location', 'Rules & Prizes'];
	}


	render() {

		ReactGA.pageview(window.location.pathname + window.location.search);

		let skipped = new Set(), setSkipped = new Set(), completed = new Set(), setCompleted = new Set();
		const steps = this.getSteps();

		const totalSteps = () => {
			return this.getSteps().length;
		};

		const isStepOptional = step => {
			return step === 1;
		};

		const handleSkip = () => {
			if (!isStepOptional(this.state.activeStep)) {
				// You probably want to guard against something like this
				// it should never occur unless someone's actively trying to break something.
				throw new Error("You can't skip a step that isn't optional.");
			}

			this.setActiveStep(prevActiveStep => prevActiveStep + 1);
			setSkipped(prevSkipped => {
				const newSkipped = new Set(prevSkipped.values());
				newSkipped.add(this.state.activeStep);
				return newSkipped;
			});
		};

		const skippedSteps = () => {
			return skipped.size;
		};

		const completedSteps = () => {
			return completed.size;
		};

		const allStepsCompleted = () => {
			return completedSteps() === totalSteps() - skippedSteps();
		};

		const isLastStep = () => {
			return this.state.activeStep === totalSteps() - 1;
		};

		const handleNext = () => {
			const newActiveStep =
				isLastStep() && !allStepsCompleted()
					? steps.findIndex((step, i) => !completed.has(i))
					: this.state.activeStep + 1;

			let myForm = document.getElementById('tournamentForm');
			let formData = new FormData(myForm);

			let tournament_start = document.getElementById('tournament_start');
			formData.append("tournament_start", new Date(tournament_start.value));
			let tournament_end = document.getElementById('tournament_end');
			formData.append("tournament_end", new Date(tournament_end.value));
			let register_start = document.getElementById('register_start');
			formData.append("register_start", new Date(register_start.value));
			let register_end = document.getElementById('register_end');
			formData.append("register_end", new Date(register_end.value));

			let tools_tag = document.getElementById('tools_tag');
			let tools_grip = document.getElementById('tools_grip');
			if(tools_tag.checked) formData.append("measure_tools", "5e57c354aa3b8e8fe7702813");
			if(tools_grip.checked) formData.append("measure_tools", "5e57c383aa3b8e8fe7702829");

			let item_length = document.getElementById('item_length');
			let item_weight = document.getElementById('item_weight');
			let item_count = document.getElementById('item_count');
			if(item_length.checked) formData.append("rank_item", "5e57c861aa3b8e8fe77029fe");
			if(item_weight.checked) formData.append("rank_item", "5e57c8a7aa3b8e8fe7702a1f");
			if(item_count.checked) formData.append("rank_item", "5e57c8c1aa3b8e8fe7702a2f");

			let criteria = document.getElementsByName('criteria');
			for( let i=0; i<criteria.length; i++) {
				if(criteria[i].checked) {
					formData.append("rank_criteria", criteria[i].value);
				}
			}

			let criteria_limit = document.getElementById('criteria_limit');
			formData.append("rank_criteria_limit", criteria_limit.value);

			let priority = document.getElementsByName('priority');
			for( let i=0; i<priority.length; i++) {
				if(priority[i].checked) {
					formData.append("rank_priority", priority[i].value);
				}
			}

			let _public = document.getElementsByName('public');
			for( let i=0; i<_public.length; i++) {
				if(_public[i].checked) {
					formData.append("public_type", _public[i].value);
				}
			}

			this.setActiveStep(newActiveStep);
		};

		const handleBack = () => {
			this.setActiveStep(prevActiveStep => prevActiveStep - 1);
		};

		const handleStep = step => () => {
			this.setActiveStep(step);
		};

		const handleComplete = () => {
			const newCompleted = new Set(completed);
			newCompleted.add(this.state.activeStep);
			setCompleted(newCompleted);

			/**
			 * Sigh... it would be much nicer to replace the following if conditional with
			 * `if (!this.allStepsComplete())` however state is not set when we do this,
			 * thus we have to resort to not being very DRY.
			 */
			if (completed.size !== totalSteps() - skippedSteps()) {
				handleNext();
			}
		};

		const handleReset = () => {
			this.setActiveStep(0);
			setCompleted(new Set());
			setSkipped(new Set());
		};

		const isStepSkipped = step => {
			return skipped.has(step);
		};

		function isStepComplete(step) {
			return completed.has(step);
		}


		return (
			<main className="tournament-page">
				<section className="tournament-banner">
					<div className="container">
						<div className="row fullscreen d-flex align-items-center justify-content-center">
							{/*<div className="banner-content text-center col-lg-8">*/}
							{/*	<h1>*/}
							{/*		<Trans i18nKey="tournament.title" />*/}
							{/*	</h1>*/}
							{/*	<p>*/}
							{/*		<Trans i18nKey="tournament.desc1" />*/}
							{/*	</p>*/}
							{/*	<p><Trans i18nKey="tournament.desc2" /></p>*/}
							{/*</div>*/}
						</div>
					</div>
				</section>

				<div className={this.state.isList ? "main-body tourney-section-gap" : "hidden"}>
					<div className="container">

						{!isMobile ?
						<div className="row single-widget search-widget">
							<form className="example" action="#">
								<input type="text" placeholder="Search Tournament" required="" id="searchKeyword"/>
								<button type="submit" className="text-uppercase"
										onClick={(e) => this.searchList('search', e)}>
									search
									<FiSearch className="ml-15"/>
								</button>
							</form>
						</div>
							: ''}

						<div className="row tournament-area-clear">
							<div className="card col-lg-2">

								<div className="single-widget category-widget">
									<h4 className="title"><FiAnchor/> Status </h4>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isOpenActive}
												onChange={(e) => this.searchList('open', e)}
												name="checkedOpen"
												color="primary"
											/>
										}
										label="OnGoing"
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isRegisterActive}
												onChange={(e) => this.searchList('register', e)}
												name="checkedReg"
												color="primary"
											/>
										}
										label="Register"
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isClosedActive}
												onChange={(e) => this.searchList('closed', e)}
												name="checkedClosed"
												color="primary"
											/>
										}
										label="Closed"
									/>
								</div>

								<div className="single-widget category-widget">
									<h4 className="title"><FiLock /> Public</h4>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isPublicActive}
												onChange={(e) => this.searchList('public', e)}
												name="checkedOpen"
												color="primary"
											/>
										}
										label="Public"
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isPrivateActive}
												onChange={(e) => this.searchList('private', e)}
												name="checkedReg"
												color="primary"
											/>
										}
										label="Primary"
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.isConditionalActive}
												onChange={(e) => this.searchList('conditional', e)}
												name="checkedClosed"
												color="primary"
											/>
										}
										label="Conditional"
									/>
								</div>

							</div>
							<div className="col-lg-10 row ">
								{this.state.items}
							</div>
						</div>
					</div>
				</div>

				<div className={this.state.isList ? "hidden" : "main-body tourney-section-gap create-tournament"}>
					<h1>Create Tournament</h1>
					{this.state.message}
					<form onSubmit={this.handleSubmit} id="tournamentForm" ref="tournamentForm">
						<Stepper alternativeLabel nonLinear activeStep={this.state.activeStep}>
							{steps.map((label, index) => {
								const stepProps = {};
								const buttonProps = {};
								// if (isStepOptional(index)) {
								// 	buttonProps.optional = <Typography variant="caption">Optional</Typography>;
								// }
								if (isStepSkipped(index)) {
									stepProps.completed = false;
								}
								return (
									<Step key={label} {...stepProps}>
										<StepButton
											onClick={handleStep(index)}
											completed={isStepComplete(index)}
											{...buttonProps}
										>
											{label}
										</StepButton>
									</Step>
								);
							})}
						</Stepper>

						{/* Step 1 */}
						<div className={this.state.activeStep === 0 ? "" : "hidden"}>
							<TournamentStep1 />
							<FormGroup className="button-center">
								<Button variant="primary" onClick={handleNext}>Next</Button>
							</FormGroup>
						</div>

						{/* Step 2 */}
						<div className={this.state.activeStep === 1 ? "" : "hidden"}>
							<TournamentStep2 fish={this.state.fish} onChange={this.sendFishData}/>
							<FormGroup className="button-center">
								<Button variant="primary" onClick={handleNext}>Next</Button>
							</FormGroup>
						</div>

						{/* Step 3 */}
						<div className={this.state.activeStep === 2 ? "" : "hidden"}>
							STEP 3
						</div>

					</form>
				</div>
			</main>
		)
	}
}

export default TournamentPage;
